import { render } from "./LogInForm.vue?vue&type=template&id=b4215a1c&scoped=true"
import script from "./LogInForm.vue?vue&type=script&lang=js"
export * from "./LogInForm.vue?vue&type=script&lang=js"

import "./LogInForm.vue?vue&type=style&index=0&id=b4215a1c&lang=scss&scoped=true"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4215a1c"]])

export default __exports__